import React from "react";
import { Dropdown, Form, Breadcrumb  } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiPlus } from "react-icons/bi";
import "./KPI.scss";
import useHasPermission from "../../../core/hooks/useHasPermission";

const KPIHeader = ({ t, hideNewActions = false, onNewCategory, onNewGoal, onNewKPI }) => {
	const { hasGoalsAndKPIsUpdatePermission } = useHasPermission();

	return (
		<div className="List_header">
			<div className="d-flex align-items-center">
				<h5 className="MH">{t("Configure.label")} </h5>
			</div>
			<div className="d-flex justify-content-end align-items-center header-actions">
				{
					!hideNewActions &&
					<>
						<Dropdown hidden={!hasGoalsAndKPIsUpdatePermission()}>
							<Dropdown.Toggle variant="primary QuickLinks_btn" id="dropdown-basic">
								<BiPlus className="m-0" /><span> {t("New.label")}</span>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item onClick={() => onNewCategory()}>{t("Category.label")}</Dropdown.Item>
								<Dropdown.Item onClick={() => onNewGoal()}>{t("Goal.label")}</Dropdown.Item>
								<Dropdown.Item onClick={() => onNewKPI()}>{t("KPI.label")}</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</>
				}
			</div>
		</div>
	);
};

export default withTranslation()(KPIHeader);
